import React from "react";
import { connect } from "react-redux";
import routes from "../../../../assets/apiRoutes.json"
import axios from "axios";
import { GridLayout } from "../../../../common/GridLayout";
import {Toolbar as MainToolbar, Item as MainItem} from 'devextreme-react/toolbar';
import { LoadIndicator } from "devextreme-react/load-indicator";
import GridLayoutManager from "../../../../gridLayoutCustomization/GridLayoutManager";

import DataGrid, {
  Column,
  Editing,
  Paging,
  Selection,
  Toolbar,
  Item,
  FilterRow,
  FilterPanel,
  FilterBuilderPopup,
  ColumnChooser,
  ColumnChooserSearch,
  ColumnFixing,
  Sorting,
  Export,
  Pager,
  HeaderFilter,
  StateStoring
} from 'devextreme-react/data-grid';

import { Button } from 'devextreme-react/button';
import { alert } from 'devextreme/ui/dialog';
import { confirm } from 'devextreme/ui/dialog';
import { createStore } from 'devextreme-aspnet-data-nojquery';
import { downloadReportFile } from "../../../../common/Utils";
const filterBuilderPopupPosition = {
  of: window,
  at: 'top',
  my: 'top',
  offset: { y: 10 },
};

const allowedPageSizes = [10, 20, 100, 500, 1000, "all"];
const dataGrid = React.createRef();
let accessToken = '';
const gridKey = "9c4cb7e5-e85f-4d48-9b28-16a4ec1c223d";
var customSelection = false;

class ExportInspection extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      loadIndicatorVisible: false,
      selectedItemKey: null,
      currentLayout: "Default",
    };

    accessToken = props.oidc.user.access_token;
    this.selectionChanged = this.selectionChanged.bind(this);
    this.onContentReady = this.onContentReady.bind(this);
    this.Export = this.Export.bind(this);
    var that = this;
    this.dataSource = createStore({
      key: 'rowid',
      loadUrl: `${window._env_.REACT_APP_APIS}/${routes.ExportInspection.GetData}`,
      onBeforeSend: function(method, ajaxOptions) {
        ajaxOptions.headers = {
          Authorization: `Bearer ${accessToken}`
        };
      }
    });
  }
  setCurrentLayout =(value)=>{
    this.setState({
      currentLayout:value
    })
  }
  loadState = () => {return GridLayout.sendStorageRequest(gridKey, "GET", accessToken,null, this.state.currentLayout);}
  saveState=(state)=> { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, this.state.currentLayout);}
  render() {
    return (
      <div className="h-100 m-0" style={{ height: '100%', overflowY: 'hidden', display: 'flex', flexDirection: 'column' }}>
         <div className="title">
          <h6
            style={{
              color: window._env_.Color2
            }}
          >
            Export Inspections
          </h6>
        </div>
        <DataGrid
          style={{ flex: '1 1 auto', minHeight: 0 }}

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }} id="gridContainer"
          onContentReady={this.onContentReady}
          ref={dataGrid}
          showBorders={true}
          className="ATConfigurationGridStyle"
          onSelectionChanged={this.selectionChanged}
          rowAlternationEnabled={true}
          allowColumnResizing={true}
          allowColumnReordering={true}
          columnAutoWidth={true}

          searchEnabled={true}
        >
          <Selection mode="multiple" showCheckBoxesMode="always" allowSelectAll={false}/>
          <Paging
            enabled={true}
          />
          <Pager
            visible={true}
            showPageSizeSelector={true}
            allowedPageSizes={allowedPageSizes}
            showNavigationButtons={true}
            showInfo={true}
          />
          <FilterRow visible={true} />
          <FilterPanel visible={true} />
          <FilterBuilderPopup position={filterBuilderPopupPosition} />
          <ColumnChooser
            enabled={true}
            title="Choose Column"
            width={290}
            height={290}
            sortOrder="asc"
          >
            <ColumnChooserSearch
              enabled={true}
              editorOptions={{ placeholder: 'Search column' }} />
          </ColumnChooser>
          <HeaderFilter visible={true} />
          <ColumnFixing enabled={true}/>,
          <Sorting mode="multiple"/>
          <StateStoring
            enabled={true}
            type="custom"
            customLoad={this.loadState}
            storageKey={gridKey}
            customSave={this.saveState}
          /> 
          <Column dataField="inspectionid" caption="Inspection Id" />
          <Column dataField="inspectiondate" caption="Inspection Date" dataType="date"/>
          <Column dataField="supervisor" caption="Supervisor"/>
          <Column dataField="inspectiontype" caption="Inspection Type"/>
          <Toolbar>
            <Item location="before">
              <div>Select inspections you want to export</div>
            </Item>
            <Item>
              <LoadIndicator
                style={{
                  height: "20px",
                  width: "20px",
                  verticalAlign: "middle",
                  marginRight: "5px",
                }}
                visible={this.state.loadIndicatorVisible}
              />
              <Button onClick={this.Export} text="Export" type="default" stylingMode="contained">
              </Button>
            </Item>
            <Item location="after">
                        <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={this.setCurrentLayout} />
                 </Item>
            <Item name="exportButton" />
            <Item name="columnChooserButton"/>
          </Toolbar>
        </DataGrid>
      </div>
    );
  }

  onContentReady(e) {
    if (!e.component._hasLoaded) {
      e.component._hasLoaded = true;
      e.component.option("dataSource", this.dataSource);
    }
  }

  Export(e) {
    if (this.state.selectedItemKey === null || this.state.selectedItemKey === undefined)
    {
      alert("Please, select a record first",
        "Error"
      );
      return;
    }

    this.setState({
      loadIndicatorVisible: true
    });

    var that = this;
    axios.post(
      `${window._env_.REACT_APP_APIS}/${routes.ExportInspection.ExportCSV}`,
      this.state.selectedItemKey,    
      {
        headers: {
          "Content-Type": "application/json",
          access_token: accessToken,
        },
      }
    ).then((res) => {
      if (res.data.isSuccess) 
      {
        // Returned so the loader stays up until the file has downloaded.
        return downloadReportFile(res.data.fileName, accessToken);
      }
      
    })
    .catch((err) => {
      alert(err, "Error");
    })
    .finally(() => {
      this.setState({
        loadIndicatorVisible: false
      });
    });

    
  }

  selectionChanged(e) {
    
    if (customSelection)
    {
      return;
    }

    var data = null;

    if (e.selectedRowKeys.length == 2)
    {
      data = e.selectedRowKeys[1];
    }
    else if (e.selectedRowKeys.length == 1)
    {
      data = e.selectedRowKeys[0];
    }
        
    customSelection = true;
    e.component.selectRows(e.currentSelectedRowKeys[0], false);
    customSelection = false;
    
    this.setState({
      selectedItemKey: data
    });
    
    
  }
}

function mapStateToProps(state) {
  return {
    ReceiptReducer: state.ReceiptReducer,
    oidc: state.oidc,
  };
}

export default connect(mapStateToProps)(ExportInspection);
